<app-packaging-navigation [itemId]="packagingPartId" [callerLevelId]="callerLevelId"
  [callerTypeId]="packagingUnitTypeId" [currentDirectoryId]="currentDirectoryId" [brandName]="brandName"
  [currentDirectoryId]="currentDirectoryId" [productName]="productName" [articleNumber]="articleNumber"
  [versionId]="packagingPartVersion" [isCurrentVersion]="isCurrentVersion"
  [hasRecyclabilityResult]="hasRecyclabilityResult" [hasLifeCycleResult]="hasLifeCycleResult"
  [creationTimestamp]="creationTimestamp">

  <div class="outer-container">
    <h1 class="mat-headline-3">{{ 'analysis.lifecycleAnalysis.cradleToGateAnalysis.title' | transloco }}</h1>
    <p><b>{{ 'analysis.lifecycleAnalysis.cradleToGateAnalysis.explanation.title' | transloco }}:</b>
      {{ 'analysis.lifecycleAnalysis.cradleToGateAnalysis.explanation.description' | transloco }}</p>
    <div id="versions-container" *ngIf="!isUserValidator">
      <mat-form-field class="form-field-versions">
        <mat-label>{{ 'home.packagingUnitHome.historyVersion' | transloco }}</mat-label>
        <mat-select [(value)]="selectedAnalysisVersion" (selectionChange)="onHistoryVersionChange($event.value)">
          <mat-option *ngFor="let analysisVersion of analysisVersions" [value]="analysisVersion">
            {{ 'analysis.calculatedOn' | transloco }}
            {{ getDateTimeString(analysisVersion[0].evaluationReferenceTimestamp) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <span id="analysis-id">
        {{ 'analysis.analysisId' | transloco }}: <b>{{analysisId}}</b>
        <button id="copy-button" mat-icon-button color="primary" [cdkCopyToClipboard]="analysisId">
          <mat-icon>content_copy</mat-icon>
        </button>
      </span>
    </div>

    <app-normalization #normForm [volumeAvailable]="actualVolume != null" [weightAvailable]="actualWeight != null"
      [actualVolume]="actualVolume" [actualWeight]="actualWeight" (normalizeClick)="doNormalize($event)">
    </app-normalization>

    <mat-tab-group>
      <mat-tab *ngFor="let element of simplifiedLcaDataSource; let countryIndex = index">
        <ng-template mat-tab-label>
          <mat-icon *ngIf="!isCountryAuthorized(element) || element.evaluatedCountryCode === 'VM'">lock</mat-icon>
          <span>{{element.countryName}}</span>
        </ng-template>
        <ng-template matTabContent>
          <div *ngIf="isUserValidator">
            <br>
            <alert *ngIf="element.validationState === validationStates.Unknown" type="info">
              {{ 'packagingUnit.messages.notValidated' | transloco }}
            </alert>
            <alert *ngIf="element.validationState === validationStates.Positive" type="success">
              {{ 'packagingUnit.messages.validationPassed' | transloco }}
            </alert>
            <alert *ngIf="element.validationState === validationStates.Negative" type="danger">
              {{ 'packagingUnit.messages.validationFailed' | transloco }}
            </alert>
          </div>
          <div class="buybox" *ngIf="!isCountryAuthorized(element) && element.evaluatedCountryCode !== 'VM'">
            <app-buying-from-shop  [buyType]="buyType.Country"
              [contentValue]="element.countryName">
            </app-buying-from-shop>
          </div>
          <div class="total" *ngIf="element.evaluatedCountryCode === 'VM'">
            {{ 'analysis.lifecycleAnalysis.warnings.theoreticalRecyclabilityNotAvailable' | transloco: {name: element.countryName} }}
          </div>
          <div *ngIf="isCountryAuthorized(element) && element.evaluatedCountryCode !== 'VM'">
            <div *ngIf="callerLevelId === packagingPartEnum.System && packagingSystem != null">
              <app-analysis-cradle-to-gate-life-cycle-packaging-system #systemForm [selectedAnalysisVersion]="getSelectedAnalysisVersionSystem(countryIndex)"
                [packagingSystem]="packagingSystem" [normalizationData]="normalizationData" [isDarkTheme]="isDarkTheme"
                [analyseTime]="this.selectedAnalysisVersion[0].evaluationReferenceTimestamp"
                [allowedEffects]="this.allowedEffects"
                (normalizeLcaResult)="normalizeProvidedLcaData($event)"
                (normalizationDataReset)="resetNormalizationData($event)">
              </app-analysis-cradle-to-gate-life-cycle-packaging-system>
            </div>

            <div *ngIf="callerLevelId === packagingPartEnum.Unit && packagingUnit != null">
              <app-analysis-cradle-to-gate-life-cycle-packaging-unit #unitForm [selectedAnalysisVersion]="getSelectedAnalysisVersionUnit(countryIndex)"
                [packagingUnit]="packagingUnit" [normalizationData]="normalizationData" [actualWeight]="actualWeight"
                [analyseTime]="this.selectedAnalysisVersion[0].evaluationReferenceTimestamp"
                [isDarkTheme]="isDarkTheme" (normalizeLcaResult)="normalizeProvidedLcaData($event)"
                [allowedEffects]="this.allowedEffects"
                (normalizationDataReset)="resetNormalizationData($event)">
              </app-analysis-cradle-to-gate-life-cycle-packaging-unit>
            </div>

            <alert type="info" class="lca-chart-alert">
              {{ 'analysis.lifecycleAnalysis.streamlinedLca' | transloco: { version: ecoinventVersion } }}
              <p class="alertSeperator"> <b>{{ 'analysis.lifecycleAnalysis.cradleToGateAnalysis.aFactor.title' | transloco}}:</b>
                <br>
                {{ 'analysis.lifecycleAnalysis.cradleToGateAnalysis.aFactor.description' | transloco}}
                <p class="alertSubSeperator">
                {{ 'analysis.lifecycleAnalysis.cradleToGateAnalysis.aFactor.Adefault' | transloco}}
                <p class="alertSubSeperator">
                {{ 'analysis.lifecycleAnalysis.cradleToGateAnalysis.aFactor.A1' | transloco}}

              <p class="alertSeperator"> <b>{{ 'analysis.lifecycleAnalysis.cradleToGateAnalysis.BiogenicCarbon.title' | transloco}}:</b>
                <br>
                {{ 'analysis.lifecycleAnalysis.cradleToGateAnalysis.BiogenicCarbon.description' | transloco}}
                <p class="alertSubSeperator">
                <i [innerHTML]="'analysis.lifecycleAnalysis.cradleToGateAnalysis.BiogenicCarbon.italicDescription' | transloco"></i>
                </p>
            </alert>
            <div *ngIf="isUserValidator" class="button-container validation-button-container">
              <button mat-raised-button color="primary" class="custom-validation-button" type="button"
                (click)="validateAnalysis(true, element)">
                <mat-icon>check</mat-icon>
                {{ 'common.text.valid' | transloco }}
              </button>
              <button mat-raised-button color="warn" class="custom-validation-button" type="button"
                (click)="validateAnalysis(false, element)">
                <mat-icon>clear</mat-icon>
                {{ 'common.text.invalid' | transloco }}
              </button>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</app-packaging-navigation>
